const state = {
    repast_list : ''
};

const mutations = {
    set_repast_list (state,val){
        state.repast_list = val;
    }
};

const actions = {

};

const getters = {

};

export default {
    state,
    mutations,
    actions,
    getters
}
